import { getModuleCache } from 'cw-ui-core';
import { legacy_connect as connect } from 'react-redux';
import AsioSecondStep from 'src/components/AsioEnablement/AsioEnablementDialog/AsioSecondStep';

const mapStateToProps = state => {
  const products = getModuleCache(state.module, ['partnerProducts']);
  const isAutomateInAsioUpgrade = getModuleCache(state.module, ['isAutomateInAsioUpgrade']);
  const selectedFeature = getModuleCache(state.module, ['selectedFeature']);
  
  const filterKeywords = selectedFeature === 'automate' || isAutomateInAsioUpgrade 
    ? ['automate'] 
    : ['manage', 'brightgauge'];
  
  const filteredProducts = products
    .filter(product => {
      const name = product.get('name')?.toLowerCase();
      return name && filterKeywords.some(keyword => name.includes(keyword));
    }).toJS();
  
  return {
    filteredProducts,
    isAutomateInAsioUpgrade
  };
};

export default connect(mapStateToProps, null)(AsioSecondStep);
